import type { ToastVariant, ToastVariantLabel } from './types';

/** `sessionStorage` key prefix; a dismissal is scoped per campaign id. */
export const TOAST_DISMISSED_STORAGE_PREFIX = 'chime-toast-dismissed';

/** Seconds the collapsible panel takes to open or close. */
export const TOAST_COLLAPSE_DURATION = 0.3;

/**
 * Shell shared by the two corner variants.
 *
 * `bg-bg-primary` rather than `bg-white`: chimekit declares `--color-white` as a
 * bare "255 255 255" triple inside `@theme inline`, so Tailwind emits
 * `background-color: 255 255 255` and nothing paints.
 *
 * `w-full` up to `sm`, then the design's fixed 480px. A bare `w-[480px]` only
 * looks full-width on a viewport narrower than 480, so every phone above that
 * got a 480px card floating inside a full-width wrapper.
 */
export const TOAST_CARD_SHELL = 'w-full rounded-2xl bg-bg-primary p-4 shadow-[0_8px_24px] shadow-kale/10 sm:w-[480px]';

/** The design sets every string in the toast to Saans Medium at 16px/1.4. */
export const TOAST_TEXT = 'font-sans text-base leading-[1.4] font-medium';

export const getToastDismissedKey = (dismissId: string) => `${TOAST_DISMISSED_STORAGE_PREFIX}:${dismissId}`;

/**
 * Contentful stores the variant as an author-facing label. Mapped here rather
 * than in `types/constants.ts` because nothing outside this component reads it.
 */
export const TOAST_VARIANT_BY_LABEL: Record<ToastVariant | ToastVariantLabel, ToastVariant> = {
  dismissable: 'dismissable',
  collapsible: 'collapsible',
  banner: 'banner',
  Dismissable: 'dismissable',
  Collapsible: 'collapsible',
  Banner: 'banner',
};
